import { IOrderRecapService, CHANNEL_RECAP_SERVICE } from "../IOrderRecapService";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ENCODABLE_TYPE_ERRORS } from "shared/broker-client-services";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OrderRecapReplicaService implements IOrderRecapService {
  protected broker: ClientMessageBroker;

  constructor(protected factory: ClientMessageBrokerFactory) {
    this.broker = this.factory.createMessageBroker(CHANNEL_RECAP_SERVICE, true, true);
  }

  public getOrderRecap(orderIds: any): Promise<Array<string>> {
    let request = new UiArguments("getOrderRecap");

    let arg1 = new FnArg(orderIds, PRIMITIVE);
    request.args = [arg1];

    return this.runOnService(request, new Array<string>());
  }

  protected runOnService(request: UiArguments, assignable: any = null): Promise<any> {
    return new Promise<any>((res, rej) => {
      this.broker.runOnService(request, PRIMITIVE).then((value: any) => {
        if (value && value.enType && value.enType == ENCODABLE_TYPE_ERRORS) {
          rej(value);
        } else {
          if (assignable && value) {
            value = Object.assign(assignable, value);
          }
          res(value);
        }
      });
    });
  }
}
